<template>
  <div class="footerContainer d-flex justify-space-between align-center pl-2 pr-6 py-4">
    <v-btn
      class="seeOrAddButton px-2"
      text
      color="primary"
      @click="() => scrollToAnalysis(userDetails.userId)"
    >
      {{ currentUserAnalysisExists ? $t('extension.footer.seeMyAnalysis') : $t('extension.footer.addMyAnalysis') }}
    </v-btn>
    <ExtensionSendButton
      :analysis="analysis"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ExtensionSendButton from './ExtensionSendButton';
import { scrollToAnalysis } from './analysisHelper';
import { types as userTypes } from '../../store/user';

export default {
  name: 'ExtensionFooter',
  components: { ExtensionSendButton },
  props: {
    analysis: {
      type: Object,
      required: false,
      default() { return {}; },
    },
  },
  data() {
    return {
      isInPersonalPortfolio: undefined,
    };
  },
  computed: {
    ...mapGetters({
      userDetails: userTypes.getters.userDetails,
    }),
    currentUserAnalysisExists() {
      if (!this.analysis.userAnalyses) return false;

      const currentUserAnalysis = this.analysis.userAnalyses.find(userAnalysis => userAnalysis.id === this.userDetails.userId);
      console.log('==== currentUserAnalysis: ', currentUserAnalysis);
      return currentUserAnalysis.auditInfo !== undefined;
    },
  },
  methods: {
    scrollToAnalysis,
  },
};
</script>
<style scoped>
.footerContainer {
  background-color: white;
}
.seeOrAddButton {
  font-size: 14px;
  text-decoration: underline;
  text-transform: none;
}
</style>
